import React, { useContext, useRef, useState } from "react";
import MedicineCard from "../MedicineCard/MedicineCard";
import {
  // ButtonsWrapper,
  MedicineListContainer,
  SearchWrapper,
  SelectAllWrapper,
  SubHeaderWrapper,
} from "./medicineList.style";
import { Checkbox, message, Popconfirm } from "antd";
import { PackSlipHeader } from "../index";
import { CheckerService_URL } from "../../../redux/Url";
import { newApiCallHandler } from "../../../services/packslip.service";
// import PSSubmitCTASection from "../PSSubmitCTASection";
import { Context } from "../../../pages/PackSlip";
import SearchMedicine from "../SearchMedicine/SearchMedicine";
const selectAllText = "Are you sure you want to select all ?";
const deSelectAllText = "Are you sure you want to deselect all ?";
const MedicineList = ({ setMedicineList, medicineList = [], psData }) => {
  const selectRef = useRef(null);
  const [searchString, setSearchString] = useState("");
  const { setIsLoading } = useContext(Context);
  const { sourceBox, destinationBox, transferOrderId } = psData;
  const onSelect = (id, value, qty) => {
    setMedicineList(
      medicineList.map((item) => {
        if (item.id === id) {
          if (qty) {
            item.pendingQty = item.totalQty - qty;
            item.packedQty = qty;
            item.checked = value;
            return item;
          }
          if (!value) {
            item.pendingQty = item.totalQty;
            item.packedQty = 0;
            item.checked = value;
            return item;
          }
          item.packedQty = item.totalQty;
          item.pendingQty = 0;
          item.checked = value;
        }
        return item;
      })
    );
    setIsLoading(false);
  };
  const isAllChecked = medicineList?.length
    ? medicineList.every((item) => item.checked)
    : false;
  const onAllSelect = (value) => {
    setIsLoading(true);
    newApiCallHandler({
      method: "POST",
      url: `${CheckerService_URL}/packing/boxes/products`,
      params: {
        boxFull: false,
        transferOrderId: transferOrderId,
        destinationBox: destinationBox,
        sourceBox: sourceBox,
        packed: false,
      },
      data: medicineList.map((item) => {
        return {
          productCode: item.productCode,
          productName: item.productName,
          packedQty: value ? item.totalQty : 0,
          batchNumber: item.batchNumber,
          checked: value,
        };
      }),
      onSuccess: (res, error) => {
        if (error) {
          setIsLoading(false);
          return message.error(error);
        }
        setMedicineList(
          medicineList.map((item) => {
            item.checked = value;
            item.pendingQty = value ? 0 : item.totalQty;
            item.packedQty = item.totalQty;
            return item;
          })
        );
        setIsLoading(false);
      },
      onFailure: (err) => {
        message.error(err);
        setIsLoading(false);
      },
    });
  };

  const renderMedicineList = () => {
    if (medicineList?.length === 0) {
      return <h3>No Medicine found.</h3>;
    }
    const medList = medicineList.filter((item) => {
      if (searchString?.length > 2) {
        return item.productName
          .toLowerCase()
          .includes(searchString?.toLowerCase());
      }
      return item;
    });
    if (medList?.length === 0) {
      return <h3>No Result found.</h3>;
    }
    return medList.map((item, i) => (
      <MedicineCard key={i} data={item} onSelect={onSelect} psData={psData} />
    ));
  };
  return (
    <>
      <MedicineListContainer>
        <PackSlipHeader
          toNumber={transferOrderId}
          from={sourceBox}
          to={destinationBox}
        />
        <SubHeaderWrapper>
          <SelectAllWrapper>
            <Popconfirm
              placement="right"
              title={isAllChecked ? deSelectAllText : selectAllText}
              onConfirm={() => {
                onAllSelect(!selectRef?.current?.checked);
              }}
              okText="Yes"
              cancelText="No"
            >
              <input
                type="checkbox"
                ref={selectRef}
                checked={isAllChecked}
                disabled={
                  medicineList?.length ? searchString?.length > 3 : true
                }
              />
            </Popconfirm>
            <div className="selectLabel">Select All</div>
          </SelectAllWrapper>
          <SearchWrapper>
            <SearchMedicine
              onSearch={setSearchString}
              disabled={!medicineList?.length}
            />
          </SearchWrapper>
        </SubHeaderWrapper>

        {renderMedicineList()}
      </MedicineListContainer>
    </>
  );
};

export default MedicineList;
